export default __webpack_public_path__ + "static/media/5.789f5d32.svg";